export const SHOP_URL = process.env.SHOP_URL

export const API_URL = process.env.API_URL
export const API_URL_SUPPLIER = `${API_URL}/supplier`
export const API_URL_SHOP = `${API_URL}/shop`

export const UNAUTHORIZED_URL = '/login'
